var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "error404-bg.3836c4ee.png",
    width: 1920,
    height: 1080
});